import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from './NavigationPage.module.css';
import routes from '~/configs';
import { FaUserTie, FaClipboardCheck, FaCarSide, FaHistory, FaSignInAlt, FaIdCard, FaUser } from 'react-icons/fa';

const cx = classNames.bind(styles);

const NavigationPage = () => {
  const navItems = [
    { to: routes.driverDetail, label: 'Chi tiết tài xế', icon: <FaUserTie /> },
    { to: routes.driverCheckIn, label: 'Check-in hàng ngày', icon: <FaClipboardCheck /> },
    { to: routes.driverWash, label: 'Rửa xe', icon: <FaCarSide /> },
    { to: routes.driverHistory, label: 'Lịch sử báo cáo', icon: <FaHistory /> },
    { to: routes.login, label: 'Đăng nhập', icon: <FaSignInAlt /> },
  ];

  return (
    <nav className={cx('navContainer')}>
      {/* Tiêu đề chính */}
      <h2 className={cx('cvtitle')}> Quản Lý Tài Xế</h2>


      {/* Các nút điều hướng */}
      <div className={cx('navLinks')}>
        {navItems.map((item, idx) => (
          <Link key={idx} to={item.to} className={cx('navButton')}>
            <span className={cx('icon')}>{item.icon}</span>
            <span>{item.label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default NavigationPage;
